import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import WithEscNavigation from '@hobs/hocs/WithEscNavigation';
import { createLoadingSelector } from '@hobs/utils/loading';
import { USER_ROLES } from '@hobs/utils/constants';
import WithRoles from '@hobs/hocs/WithRoles';

import {
  getServiceRequest,
  update,
  calculateByDays,
  clearCalculateByDays,
  getFooter,
  confirmServiceRequest,
  clearFooter
} from '@hobs/actions/serviceRequests';
import { createCustomAdditionalServiceRequest } from '@hobs/actions/additionalServiceRequest';
import {
  createAcceptResponse,
  createRejectResponse,
  changeRequestAcceptResponse,
  changeRequestRejectResponse,
  createCancellationRequest
} from '@hobs/actions/tickets';
import {
  uploadAttachments,
  setAttachments,
  deleteAttachment,
  clearAttachments
} from '@hobs/actions/attachment';
import { queryLocations } from '@hobs/actions/locations';
import { queryOData, resetOData } from '@hobs/actions/odata';

import _ServiceRequestCustom from '@hobs/containers/ServiceRequestCustom';

import {
  forSubmit,
  create,
  update as updateCustom,
  remove
} from '../../actions/customServiceRequests';

class ServiceRequestCustom extends _ServiceRequestCustom {
  getServiceRequestsGridUrl() {
    return '/requested-services';
  }

  getCatalogItemsQueryUrl() {
    return 'CatalogItemsQueryForServiceRequest';
  }

  getHistoryPath() {
    const { match } = this.props;
    return `/custom-service-request-history/${match.params.serviceRequestId}`;
  }

  getEditPath() {
    const { match } = this.props;
    return `/custom-service-request/${match.params.serviceRequestId}`;
  }

  getShowPath() {
    return null;
  }

  getDiscussionInitials() {
    const { t } = this.props;
    return t('HN');
  }

  _remove() {
    const { match, remove } = this.props;

    return remove(match.params.serviceRequestId);
  }

  canUserAcceptResponse() {
    const { hasUserPermission } = this.props;

    return (
      !hasUserPermission(USER_ROLES.READONLY) &&
      !hasUserPermission(USER_ROLES.HOST_UNIT)
    );
  }

  getCustomServiceRequestEditUrl(serviceRequestId) {
    return `/custom-service-request/${serviceRequestId}`;
  }

  getChangeHistoryPath() {
    const { match } = this.props;
    return `/service-request/${match.params.serviceRequestId}/change-history`;
  }
}

const serviceRequestsLoading = createLoadingSelector([
  'ServiceRequests/Get',
  'CustomServiceRequests/ForSubmit'
]);

const mapStateToProps = state => ({
  isLoading: serviceRequestsLoading(state),
  forSubmitData: state.customServiceRequests.forSubmit,
  calculateByDaysData: state.serviceRequests.calculateByDays,
  locations: state.locations.query,
  oData: state.odata,
  serviceRequest: state.serviceRequests.item,
  attachments: state.attachment.attachments,
  footer: state.serviceRequests.footer
});

const mapDispatchToProps = {
  queryLocations,
  forSubmit,
  calculateByDays,
  queryOData,
  resetOData,
  clearCalculateByDays,
  create,
  update,
  updateCustom,
  getServiceRequest,
  remove,
  uploadAttachments,
  setAttachments,
  deleteAttachment,
  clearAttachments,
  confirmServiceRequest,
  createCustomAdditionalServiceRequest,
  getFooter,
  createAcceptResponse,
  createRejectResponse,
  changeRequestAcceptResponse,
  changeRequestRejectResponse,
  createCancellationRequest,
  clearFooter
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslation()(
    withRouter(WithRoles(WithEscNavigation(ServiceRequestCustom)))
  )
);
